import React, { useState } from "react";
import {
  CButton,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CSpinner,
} from "@coreui/react";
import { formatCurrency } from "../../utils/currency";
import { formatDate } from "./../../utils/string";
import { PaymentMethodSourceLabel } from "../../features/PaymentMethods/components/PaymentMethodSourceLabel";

interface PropsInterface {
  amount: number;
  paymentMethod: {
    providerName: string;
    last4: string;
    type: string;
    expiryDate?: string | null;
    status?: string | null;
  };
  resolve: any;
  reject: any;
}

const MakePaymentModal: React.FC<PropsInterface> = (props) => {
  const { amount, paymentMethod, resolve, reject } = props;
  const [isSubmitting, setSubmitting] = useState(false);

  return (
    <CModal show onClose={reject}>
      <CModalHeader>
        <strong>Confirm One-Time Payment</strong>
      </CModalHeader>
      <CModalBody>
        <p>
          I authorize King Energy to electronically debit my{" "}
          <PaymentMethodSourceLabel paymentMethod={paymentMethod} /> account in
          the amount of <strong>{formatCurrency(amount)}</strong> on{" "}
          <strong>{formatDate()}</strong>, and, if necessary, electronically
          credit my account to correct erroneous debits.
        </p>
        <p>Are you sure you want to make this one-time payment?</p>
      </CModalBody>
      <CModalFooter style={{ display: "flex" }}>
        <CButton
          color="primary"
          style={{ flex: 2 }}
          disabled={isSubmitting}
          onClick={() => {
            setSubmitting(true);
            resolve();
          }}
        >
          {isSubmitting && (
            <CSpinner
              size="sm"
              style={{ marginRight: 8, verticalAlign: "middle" }}
            />
          )}
          Make One-Time Payment
        </CButton>
        <CButton
          color="secondary"
          style={{ flex: 1 }}
          disabled={isSubmitting}
          onClick={reject}
        >
          Cancel
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default MakePaymentModal;
